module.exports = __webpack_public_path__ + "img/custom-mark.db4922bd.svg";